export default {
	setQuiz({ commit }, quiz) {
		commit('setQuiz', quiz);
	},
	addAnswer({ commit }, data){
		commit('chooseAnswer', data);
	},
	nextQuestion({commit}){
		commit('nextQuestion');
	},
	backQuestion({commit}){
		commit('backQuestion');
	},
	setStartQuiz({commit}){
		commit('setStartQuiz');
	},
	updateTimePassed({commit}){
		commit('updateTimePassed');
	},
	checkFinish({commit}){
		commit('checkFinish');
	},
	doneQuestion({commit}){
		commit('doneQuestion');
	},
};
